// extracted by mini-css-extract-plugin
module.exports = {"title":"InstitutionalMenu_title__3Gx6v","navListWrapper":"InstitutionalMenu_navListWrapper__3EKN4","navList":"InstitutionalMenu_navList__3-VpA"};